import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme) => ({
    title: {
        fontWeight: 'bold',
        marginTop: theme.spacing(3)
    }
}))